<template>
    <div class="map_page">
        <div class="bloco_texto">
            <h1>Como chegar</h1>

            <h2>Para vir de Carro, clique no mapa com as instruções do Google Maps, 
                ou busque por <b>Templo EDEM</b> em seu aplicativo de viagem.
            </h2>
            <p>Rua José Carlos Piccirillo, 430, Gabriel Piza. São Roque - SP</p>
        </div>
        <div class="bloco_mapa">
            <div class="map_container">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.0270387413134!2d-47.121757926190064!3d-23.56747236181383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cf0d17df82a253%3A0x89b226be2a11e50f!2sTemplo%20EDEM!5e0!3m2!1spt-BR!2sbr!4v1752505594082!5m2!1spt-BR!2sbr" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MapPage',
    mounted() {
        console.log('MapPage component mounted');
    }
};
</script>
<style scoped>
@font-face {
  font-family: 'Amiri';
  src: url('@/assets/fonts/Amiri/Amiri-Regular.ttf') format('truetype'),
      url('@/assets/fonts/Amiri/Amiri-Bold.ttf') format('truetype'),
      url('@/assets/fonts/Amiri/Amiri-Italic.ttf') format('truetype'),
      url('@/assets/fonts/Amiri/Amiri-BoldItalic.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Abhaya Libre';
  src: url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-Regular.ttf') format('truetype'),
      url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-Bold.ttf') format('truetype'),
      url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-Medium.ttf') format('truetype'),
      url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-SemiBold.ttf') format('truetype'),
      url('@/assets/fonts/Abhaya_Libre/AbhayaLibre-ExtraBold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@media(max-width: 922px) {
    h1, h2, p {
        color: #333;
        display: inline-block;
        font-weight: bold;
        font-family: 'Abhaya Libre';
    }
    h1{
        font-size: 3em;
        width: 100%;
        text-align: center;
        padding-top: 2vh;
    }
    h2{
        padding-left: 2vw;
        padding-top: 2vh;
        padding-right: 5vw;
    }
    p{
        padding-left: 2vw;
        font-size: 1.5em;
    }
    .bloco_mapa {
        display: grid;
        justify-content: center;
        align-items: center;
    }
    .bloco_texto{
        display: block;
        justify-content: center;
        align-items: center;
        width: 100vw; /* Full viewport width */
        /* background-color: #ffefbc; */
        font-size: 1em;
        position: relative;
        
    }
    .bloco_mapa .map_container iframe {
        width: 98vw;
        height: 100%;
        border: 0;
        margin-left: 2vw;
        margin-right: 2vw;
        border: 10px solid #8ccf48;
        
    }
    .bloco_mapa .map_container {
        margin: 2vw auto;
        width: 98%;
        position: relative;
        justify-content: center;
        text-align: center;
        /* background-color: #8ccf48; */

    }
    .map_page {
        display: block;
        align-items: center;
        justify-content: center;
        background-color: #ffefbc;
        margin-top:2vh;
        width: 98vw;
    }
}
@media(min-width: 922px) {
    h1, h2, p {
        color: #333;
        display: inline-block;
        font-weight: bold;
        font-family: 'Abhaya Libre';
    }
    h1{
        font-size: 3em;
        width: 100%;
        text-align: center;
        padding-top: 2vh;
    }
    h2{
        padding-left: 2vw;
        padding-top: 2vh;
        padding-right: 5vw;
    }
    p{
        padding-left: 2vw;
        font-size: 1.5em;
    }
    .bloco_mapa {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 2vh;;
        height: 100vh; /* Full viewport height */
        width: 50vw; /* Full viewport width */
        /* background-color: #ffefbc; */
    }
    .bloco_texto{
        display: block;
        justify-content: center;
        align-items: center;
        height: 100vh; /* Full viewport height */
        width: 50vw; /* Full viewport width */
        /* background-color: #ffefbc; */
        font-size: 1em;
        position: relative;
        
    }
    .bloco_mapa .map_container iframe {
        width: 95%;
        height: 70%;
        border: 0;
        margin: 0;
        border: 10px solid #8ccf48;
        
    }
    .bloco_mapa .map_container {
        margin: 0 0 0 0;
        width: 100%;
        height: 100%;
        position: relative;
        /* background-color: #8ccf48; */

    }
    .map_page {
        display: flex;
        flex-direction: row;
        align-items: left;
        justify-content: center;
        width: 98vw;
        height: 100vh;
        background-color: #ffefbc;
    }
}
</style>